<template>
  <transition name="fade">
    <div class='member-guide' v-show="value">
      <div class="mask">
        <div class="wrapper">
          <div class="title">{{titleText}}</div>
          <div class="content" v-if="isMember">
            续费VIP方式：<br />
            1. 联系您的智伴优学导师（优学APP—个人中心查看导师），获取邀请海报，即可续费VIP<br />
            2. 特殊疑问，请联系智伴优学客服处理
          </div>
          <div class="content" v-else>
            开通VIP方式：<br />
            1. 购买智伴学习机器人，登录APP，绑定设备后即可领取VIP<br />
            2. 联系智伴优学机器人经销商获得二维码邀请，即可购买开通VIP<br />
            3. 咨询智伴优学客服，获取购买资格，客服电话：400-0004-218
          </div>
          <div class="bottom">
            <button class="bottom-btn" @click="$emit('confirm')">明白了</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'click'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isMember: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    titleText () {
      return this.isMember ? "如何续费VIP": "如何开通VIP"
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.member-guide{
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.mask{
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(0,0,0,0.6);
}
.wrapper{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  min-width: 300px;
}
.wrapper .title{
  padding: 10px;
  text-align: center;
  font-size: 16px;
  line-height: 30px;
  font-weight: bold;
  color: #404040;
}
.wrapper .content{
  padding: 0 15px 20px;
  font-size: 14px;
  line-height: 20px;
  color: #5d5353;
}
.wrapper .bottom{
  text-align: center;
  padding: 10px 0;
}
.bottom-btn{
  background: #FF6886;
  color: #ffffff;
  font-size: 16px;
  line-height: 30px;
  width: 70%;
  border-radius: 15px;
}
</style>
